<span class="soon-badge" [style.--soon-h]="height() + 'px'" [matTooltip]="transloco.translate('common.comingSoon')" matTooltipPosition="right">SOON</span>
